var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagementNoUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30613;}\n\t.st1{opacity:0.15;fill:#B1B7C5;}\n\t.st2{clip-path:url(#SVGID_1_);}\n\t.st3{fill:#B1B7C5;}\n\t.st4{fill:#808693;}\n\t.st5{fill:#FCFCFC;}\n\t.st6{fill:#EFF1F3;}\n\t.st7{fill:#E6E6E6;}\n\t.st8{opacity:0.72;fill:#B1B7C5;}\n\t.st9{fill:#00BDAA;}\n\t.st10{opacity:0.72;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.5,
    cy: 283.5,
    r: 171.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.1,292.1h-33.7c-13.7,0-24.9,11.2-24.9,24.9v21.6h83.3h0.3v-21.6C326,303.4,314.8,292.1,301.1,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.3,289.7c-3.6-2.4-7.9-4-12.5-4H205c-12.2,0-21.9,9.7-21.9,21.9v19.2h50.2v-9.7 C233.3,305.8,238.8,295.8,247.3,289.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M361.9,285.7h-29.8c-4.3,0-8.2,1.2-11.6,3.3c8.8,6.1,14.6,16.4,14.6,28v9.7h48.6v-19.2 C383.8,295.5,374.1,285.7,361.9,285.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 284.1,
    cy: 255.6,
    r: 27.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 347,
    cy: 252.6,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 219.9,
    cy: 252.6,
    r: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementNoUsers);
export default __webpack_public_path__ + "static/media/user_management_no_users.e6135264b1eb5828dd5459e097fe4f70.svg";
export { ForwardRef as ReactComponent };